import { useGoogleOneTapLogin } from '@react-oauth/google';
import pageSlugs from '@src/components/layout/pageSlugs';
import { setGoogleToken } from '@src/services/auth';
import { useUserUpdate } from '@src/services/userContext';
import api from '@src/utils/api.js';
import { navigate } from 'gatsby';
import React from 'react';
import { useTranslation } from 'react-i18next';

const googleOneTap = () => {
  const { i18n } = useTranslation();
  const updateUser = useUserUpdate();

  useGoogleOneTapLogin({
    onSuccess: async (googleResponse) => {
      const response = await api.post('auth/googleLogin', {
        googleToken: googleResponse.credential,
      });

      if (response?.errorCode === 'GOOGLE_LOGIN_FAILED_USER_NOT_FOUND') {
        setGoogleToken({
          googleToken: googleResponse.credential,
        });
        navigate(`/${pageSlugs.registracija[i18n.language]}`);
      } else {
        updateUser({
          id: response?.id,
          isInProject: response?.isInProject,
          userToken: response?.authToken,
          complete: response?.complete,
          email_confirmed: response?.email_confirmed,
          email: response?.email,
          avatar_url: response?.avatar_url,
          role: response?.role,
          display_name: response?.display_name,
          childrenData: response?.childrenData,
        });
      }
    },
    onError: () => {
      console.log('Login Failed');
    },
  });

  return <></>;
};

export default googleOneTap;
